import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Modal, IconButton, Typography } from '@mui/material';

import { StyleModal } from '../../../../modal/styles';

const FileStatusModal = ({ openFileModal, handleCloseFileModal, fileModaTitle, fileModalMessage, status }) => {
  return (
    <Modal
      open={openFileModal}
      onClose={handleCloseFileModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...StyleModal, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton
          aria-label="close"
          onClick={handleCloseFileModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        {status === 'error' && <ErrorIcon fontSize="large" sx={{ color: 'red', marginTop: '10px' }} />}
        {status === 'success' && <CheckCircleIcon fontSize="large" sx={{ color: 'green', marginTop: '10px' }} />}

        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
          {fileModaTitle}
        </Typography>
        <Typography id="modal-modal-title" variant="h6" component="h3">
          {fileModalMessage}
        </Typography>
      </Box>
    </Modal>
  );
};

export default FileStatusModal;
